import Mustache from 'mustache'; // eslint-disable-line no-unused-vars
import UIkit from 'uikit';
import 'uikit/dist/css/uikit.css';

// lazyload Google Map
const tooltip = `<div class="gmap-tooltip">
	<div class="gmap-tooltip__address">
	<strong>{{name}}</strong><br/>
	{{street}}, {{city}}<br/><br/>
	<a href="http://maps.google.com/maps?saddr={{mylat}},{{mylong}}&daddr={{lat}},{{long}}&ll=" target="_blank">Route anzeigen <span
	class="workshop-data__km">({{distance}}km)</span></a></span></a>
	<br/>
	<br/>
		<a href="{{link}}" class="tooltip__link" data-category="Termin vereinbaren Form" data-action="click" data-label="EuroWarsztat s.c.">
			Termin vereinbaren
		</a>
		<a href="{{linkMore}}" class="tooltip__link" data-category="Sie wurden zur Workshop-Seite weitergeleitet." data-action="click" data-label="{{name}}">
			mehr
		</a>
	</div>

	</div>`;

const workshopTemplate = `

<div class="find__item" id="id_{{id}}" data-dist="{{distance}}">
    <div class="find__item-left">
        <div class="find__item-data">
            <p class="find__item-title">{{name}}</p>
            <div class="city__pins">
                <div class="find__item-adress">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.68163 0.931152C5.13564 0.932708 3.65356 1.39914 2.56038 2.22817C1.4672 3.05719 0.852148 4.18115 0.850098 5.35357C0.850098 8.52849 6.28314 12.505 6.51398 12.6727C6.55887 12.7058 6.61902 12.7243 6.68163 12.7243C6.74424 12.7243 6.80439 12.7058 6.84929 12.6727C7.08012 12.505 12.5132 8.52849 12.5132 5.35357C12.5111 4.18115 11.8961 3.05719 10.8029 2.22817C9.7097 1.39914 8.22762 0.932708 6.68163 0.931152ZM6.68163 7.38051C6.153 7.38051 5.63625 7.26163 5.19671 7.0389C4.75717 6.81618 4.4146 6.49962 4.2123 6.12924C4.01 5.75887 3.95707 5.35132 4.0602 4.95813C4.16333 4.56494 4.41789 4.20378 4.79169 3.9203C5.16548 3.63683 5.64173 3.44378 6.1602 3.36557C6.67867 3.28736 7.21608 3.3275 7.70446 3.48092C8.19285 3.63433 8.61028 3.89413 8.90397 4.22746C9.19766 4.56079 9.35442 4.95268 9.35442 5.35357C9.35399 5.89105 9.07226 6.40642 8.57111 6.78647C8.06996 7.16653 7.39037 7.38018 6.68163 7.38051Z" fill="black"/>
                    </svg>
                    <p>{{street}} {{city}}</p>
                </div>
                <a href="http://maps.google.com/maps?saddr={{mylat}},{{mylong}}&daddr={{lat}},{{long}}&ll=" target="_blaknk" class="city__item-show">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 0C5.40545 0 2.48108 2.92437 2.48108 6.51888C2.48108 10.9798 8.31487 17.5287 8.56325 17.8053C8.79655 18.0651 9.20387 18.0647 9.43674 17.8053C9.68512 17.5287 15.5189 10.9798 15.5189 6.51888C15.5188 2.92437 12.5945 0 9 0ZM9 9.79871C7.19149 9.79871 5.7202 8.32739 5.7202 6.51888C5.7202 4.71037 7.19152 3.23909 9 3.23909C10.8085 3.23909 12.2798 4.71041 12.2798 6.51892C12.2798 8.32743 10.8085 9.79871 9 9.79871Z" fill="#143071"/>
                    </svg>
                    <p>Wegbeschreibung anzeigen ({{distance}}km)</p>
                </a>
            </div>
            <p class="find__item-phone">
                telefon:
                <span class="find__item-hidden hidden">
                    <a href="tel:{{number}}">{{number}}</a>
                </span>
                <span class="find__item-see showClick" data-category="Siehe die Nummer" data-action="click" data-label="">Siehe die Nummer</span>
                <span class="find__item-open">
                    Öffnungszeiten: {{openHours}}
                </span>
            </p>
        </div>
    </div>
    <div class="find__item-right">
        <a class="find__item-visit" href="{{link}}" data-category="Termin vereinbaren Form" data-action="click" data-label="EuroWarsztat s.c.">
            Termin vereinbaren
        </a>
        <a class="find__item-more" href="{{linkMore}}" data-category="Sie wurden zur Workshop-Seite weitergeleitet." data-action="click" data-label="{{name}}">
            mehr
        </a>
    </div>
</div>

`;


let htmlTemplate = '';
let workShopTemplateData = '';
const htmlWrapper = document.querySelector('.find__list');
const splitGmap = document.getElementById('gmap'); // Map container
if (typeof (splitGmap) !== 'undefined' && splitGmap != null) {
	let intervalCounter = '';
	let mapView = 0;

	const dataG = splitGmap.dataset.json;
	const markers = [];
	const image = splitGmap.getAttribute('data-icon-all');
	let fetchedPosition = {};
	// const imageAlter = gmap.getAttribute('data-icon-active');
	// const cluster = splitGmap.getAttribute('data-icon-cluster');
	let map;

	// vars for measure distance
	let directionsService;
	let directionsDisplay;
	let origin;
	let destination;

	// check if google api has been loaded
	const intervalGMap = setInterval(() => {
		if (typeof google === 'object') {
			initGMap();
			clearInterval(intervalGMap);
		} else if(intervalCounter <= 5) {
			// console.log('Bład Google API');
			intervalCounter += 1;
		}
	}, 1000);

	// initialization of map when in vieport
	function initGMap() {
		
		UIkit.scrollspy(splitGmap);
		splitGmap.addEventListener('inview', () => {
			if (mapView != 1) {
				// for prevent uikit bug, uikit inits 'inview' 7 times
				mapView = 1;
				loadGMap();
				if (dataG) {
					const reg = new RegExp('^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}');
					const getPositionLocation = document.querySelectorAll('.hero__find');
					

					function showPosition(position) {
						if ( splitGmap.getAttribute('data-is-filtered') == 0 ) {
							map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
						}
						fetchedPosition.lat = position.coords.latitude;
						fetchedPosition.lng = position.coords.longitude;
						
						setMarkers(fetchedPosition, function(){
							let wrapper = document.querySelector('.find__list');
							wrapper.append(...Array.from(wrapper.querySelectorAll(`.find__item`)).sort(function (a, b) {
								return +a.dataset.dist - +b.dataset.dist;
							}));
							wrapper.querySelector(`.find__item`).style.backgroundColor = '#efefef';
						});
					}
					function errorCallback(error) {
						navigator.geolocation.getCurrentPosition(showPosition);

						// //error marker
						// const latLng = new google.maps.LatLng(
						// 	52.237049,
						// 	21.017532,
						// );
						// map.setCenter(latLng);
						// const marker = new google.maps.Marker({
						// 	position: latLng,
						// 	map,
						// 	title: 'Błąd geolokalizacji',
						// 	icon: {
						// 		path: google.maps.SymbolPath.CIRCLE,
						// 		scale: 0
						// 	},
						// });
						// var contentString = '<div id="content">'+
						// 					'<div id="siteNotice">'+
						// 					'</div>'+
						// 					'<p style="margin:0;"><b>Nie udało się ustalić dokładnej lokalizacji.</b> ' +
						// 						'<br>Sprawdź ustawienia lokalizacji w swoim urządzeniu <br>lub zresetuj ustawienia witryny w przeglądarce.</p>'+
						// 					'</div>';
						// var infowindow = new google.maps.InfoWindow({
						// 	content: contentString
						// });
						// google.maps.event.addListener(marker, 'click', function() {
						// 	infowindow.open(map,marker);
						// });
						// infowindow.open(map,marker);
						if(document.querySelector('.no-localization-info')) {
							document.querySelector('.no-localization-info').style.opacity = 1;
							document.querySelector('.no-localization-info').style.display = 'block';
							setTimeout(() => {
								document.querySelector('.no-localization-info').style.opacity = 0;
								document.querySelector('.no-localization-info').style.display = 'none';

							}, 5000);
						}
					}

					function getPosition() {
						navigator.geolocation.getCurrentPosition(showPosition, errorCallback);
					}

					function getPositionClick() {
						navigator.geolocation.getCurrentPosition(showPosition);
					}

					getPosition();

					if (typeof (getPositionLocation) !== 'undefined' && getPositionLocation != null) {
						getPositionLocation.forEach((item) => {						
							item.addEventListener('click', (e) => {
								getPositionClick();
							});
						});
					}
					setMarkers(fetchedPosition);
				} else {
					const latLng = new google.maps.LatLng(
						Number(splitGmap.getAttribute('data-map-center-lat')),
						Number(splitGmap.getAttribute('data-map-center-lng')),
					);
					// Creating a marker and putting it on the map
					const marker = new google.maps.Marker({
						position: latLng,
						map,
						title: splitGmap.getAttribute('data-title'),
						icon: image,
					});
				}
			}
		});
	}

	// inits map with first set of markers
	function loadGMap() {

		const mapG = new google.maps.Map(splitGmap, {

			center: {
				lat: Number(splitGmap.getAttribute('data-map-center-lat')),
				lng: Number(splitGmap.getAttribute('data-map-center-lng')),
			},

			zoom: Number(splitGmap.getAttribute('data-map-zoom')),
			mapTypeControl: false,
			zoomControl: false,
			panControl: false,
			fullscreenControl: true,
			streetViewControl: false,
			// on file end
		
		});
		map = mapG;
	}
	
	const displayRoute2 = (lat1, lon1, lat2, lon2) => {
		const p = 0.017453292519943295; // Math.PI / 180
		const c = Math.cos;
		const a = 0.5 - c((lat2 - lat1) * p) / 2
			+ c(lat1 * p) * c(lat2 * p)
			* (1 - c((lon2 - lon1) * p)) / 2;

		return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
	};

	// adds markers to map
	function setMarkers(position, callback) {
		fetch(dataG)
			.then((resp) => resp.json())
			.then((resp) => {
				const infoWindow = new google.maps.InfoWindow();
				const bounds = new google.maps.LatLngBounds();
				let important = '';
				resp.forEach((point) => {
					const latLng = new google.maps.LatLng(point.latitude, point.longitude);
					// create marker
					const marker = new google.maps.Marker({
						position: latLng,
						map,
						title: point.title,
						icon: image,
					});

					(function (marker, resp) {
						// Attaching a click event to the current marker
						google.maps.event.addListener(marker, 'click', () => {
							const viewData = {
								id: point.id,
								street: point.street,
								city: point.city,
								name: point.name,
								number: point.number,
								openHours: point.openHours,
								link: point.link,
								linkMore: point.linkMore,
								lat: point.latitude,
								long: point.longitude,
								distance: isNaN(distancePromise.toFixed()) ? '--' : distancePromise.toFixed(),
								mylat: position.lat,
								mylong: position.lng
							};
							htmlTemplate = Mustache.render(
								tooltip, viewData,
							);
							infoWindow.setContent(htmlTemplate);
							infoWindow.open(map, marker);
							htmlTemplate = '';
							destination = latLng;
							// displayRoute();

							(function() {
								function findPosition(obj) {
								
									
									
									var currenttop = 0;
									if (obj.offsetParent) {
										do {
											currenttop += obj.offsetTop;
										} while ((obj = obj.offsetParent));
										return currenttop;
									}
								}

								document.querySelectorAll(".find__item").forEach(item => {
									item.style.backgroundColor = '#fff';
								});
								
								document.querySelector('.find__data').scrollTo({
									top: findPosition(document.querySelector('#id_'+viewData.id)) - document.querySelector('.find__data').offsetTop - 250,
									left: 0,
									behavior: "smooth",
								});
								document.querySelector('#id_'+viewData.id).style.backgroundColor = '#efefef';
								
							})();
						});
					}(marker, resp));
					// Dodanie markera do tablicy
					markers.push(marker);
					bounds.extend(marker.getPosition());

					const distancePromise = displayRoute2(position.lat, position.lng, point.latitude, point.longitude);

					const viewData = {
						id: point.id,
						street: point.street,
						city: point.city,
						name: point.name,
						number: point.number,
						openHours: point.openHours,
						link: point.link,
						linkMore: point.linkMore,
						lat: point.latitude,
						long: point.longitude,
							distance: isNaN(distancePromise.toFixed()) ? '' : distancePromise.toFixed(),
						mylat: position.lat,
						mylong: position.lng

					};
					workShopTemplateData = Mustache.render(
						workshopTemplate, viewData,
					);
					important += workShopTemplateData;
					// Count number of workshop
					const items = document.querySelectorAll(".find__list .find__item");
					const count = items.length;

					const cityNumber = document.querySelector(".city__number span");
					if (cityNumber) {
						cityNumber.textContent = count;
					}
					
				});
				htmlWrapper.innerHTML = important;
				map.fitBounds(bounds); //auto-zoom
				function showNumberTo()
				{
					document.querySelectorAll(".showClick").forEach(button => {
						button.addEventListener("click", function () {
							let parent = this.parentElement;
							let hiddenSpan = parent.querySelector(".hidden");
							let wsPhone = document.querySelector(".info-phone");
					
							if (hiddenSpan) {
								hiddenSpan.classList.remove("hidden");
							}
							else if (wsPhone)
							{
								wsPhone.classList.remove("hidden");
							}
					
							this.style.display = "none";
						});
					});
				}

				showNumberTo();

				setTimeout(()=> {
					const seeMore = document.querySelectorAll('.find__item-more');
					const visit = document.querySelectorAll('.find__item-visit');

					seeMore.forEach(item => {
						item.addEventListener('click', ()=> {
							ga_event(item)

						})
					});
					visit.forEach(item => {
						item.addEventListener('click', ()=> {
							ga_event(item)

						})
					})
				},1000);
				
				if (typeof position.lat !== 'undefined' && position.lat !== null) {
					const latLng = new google.maps.LatLng(position.lat, position.lng);
					let marker = '';
					marker = new google.maps.Marker({
						position: latLng,
						map,
						icon: position,
						size: 60,
						width: 6,
					});
					(function (marker) {
						infoWindow.setContent('Ihr Standort');
					}(marker));
					markers.push(marker);
					// eslint-disable-next-line no-empty
				}
				if(typeof callback === 'function') {
					callback();
				}
			})
			.catch((error) => {
				 // console.log('Bład pobierania danych', error);
			});
	}
}

(function(){
	setTimeout(function() {
		let wrapper = document.querySelector('.find__list');
		if(!!wrapper) {
			wrapper.append(...Array.from(wrapper.querySelectorAll(`.find__item`)).sort(function (a, b) {
				return +a.dataset.dist - +b.dataset.dist;
			}));
		}

		document.querySelectorAll(".showClick").forEach(button => {
			button.addEventListener("click", function () {
				let parent = this.parentElement;
				let hiddenSpan = parent.querySelector(".hidden");
				let wsPhone = document.querySelector(".info-phone");
		
				if (hiddenSpan) {
					hiddenSpan.classList.remove("hidden");
				}
				else if (wsPhone)
				{
					wsPhone.classList.remove("hidden");
				}
		
				this.style.display = "none";
			});
		});
	}, 1500);
})();
